export enum OrdersTypeEnum {
  PatientOnly = 'PatientOnly',
  ExpressLab = 'ExpressLab',
  SelectedLab = 'SelectedLab',
}
